var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpCabinetProjectSaleStartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 15C3.125 9.4025 3.125 6.6025 4.86375 4.86375C6.6025 3.125 9.40125 3.125 15 3.125C20.5975 3.125 23.3975 3.125 25.1362 4.86375C26.875 6.6025 26.875 9.40125 26.875 15C26.875 20.5975 26.875 23.3975 25.1362 25.1362C23.3975 26.875 20.5987 26.875 15 26.875C9.4025 26.875 6.6025 26.875 4.86375 25.1362C3.125 23.3975 3.125 20.5987 3.125 15Z",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0098 13.135C14.5125 13.135 14.0356 13.3325 13.6839 13.6842C13.3323 14.0358 13.1348 14.5127 13.1348 15.01C13.1348 15.5073 13.3323 15.9842 13.6839 16.3358C14.0356 16.6875 14.5125 16.885 15.0098 16.885C15.507 16.885 15.984 16.6875 16.3356 16.3358C16.6872 15.9842 16.8848 15.5073 16.8848 15.01C16.8848 14.5127 16.6872 14.0358 16.3356 13.6842C15.984 13.3325 15.507 13.135 15.0098 13.135ZM15.0098 13.135V8.75M18.7685 18.775L16.3323 16.34",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpCabinetProjectSaleStartIcon);
export default __webpack_public_path__ + "static/media/lp_cabinet_project_sale_start_icon.aef14fa92d9cd3a4135b8a387849bb35.svg";
export { ForwardRef as ReactComponent };